import { hasKey } from '@plato/shared-util/object';
import z from 'zod';

const globalConfigName = '__APP_CONFIG__';

const config =
    typeof window !== 'undefined' && hasKey(window, globalConfigName) ? window[globalConfigName] : {};

export type AppEnvironmentConfigValue =
    | boolean
    | null
    | number
    | string
    | undefined
    | AppEnvironmentConfigValue[]
    | { [key: string]: AppEnvironmentConfigValue };

export type AppEnvironmentConfig = {
    APP_ENV: string;
    [key: string]: AppEnvironmentConfigValue;
};

const appEnvironmentConfigSchema = z.object({
    APP_ENV: z.string().default('development'),
});

export function getAppEnvironmentConfig(): AppEnvironmentConfig;
export function getAppEnvironmentConfig<T>(schema: z.ZodType<T>): T;
export function getAppEnvironmentConfig(schema: z.core.$ZodType = appEnvironmentConfigSchema): unknown {
    return z.parse(schema, config);
}

export function getAppEnvironmentName(): string {
    if (process.env.NODE_ENV === 'development') {
        return 'development';
    }
    return getAppEnvironmentConfig().APP_ENV || 'development';
}

export function isProduction(): boolean {
    return getAppEnvironmentName() === 'production';
}
